import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  focusVisibleSelector
} from "./chunk.ZLFKGBZ6.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  $,
  r,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/progress-dot/progress-dot.ts
import { t } from "i18next";

// src/components/progress-dot/progress-dot.style.ts
var progress_dot_style_default = r` ${component_styles_default} :host { --dot-size: 14px; display: flex; } .progress-dot { display: inline-block; margin: 0 var(--sl-spacing-2x-small); border-radius: var(--sl-border-radius-circle); border: none; padding: 0; } .progress-dot:not(.progress-dot--active) { cursor: pointer; background: var(--progress-dot-active-background); } .progress-dot${focusVisibleSelector} { outline: none; box-shadow: var(--sl-focus-ring); } .progress-dot:not(.progress-dot--active)${focusVisibleSelector} { background: var(--progress-dot-active-background); } .progress-dot:not(.progress-dot--active):hover { background: var(--progress-dot-active-background); } .progress-dot:not(.progress-dot--active) { width: var(--dot-size); height: var(--dot-size); background: var(--sl-color-primary-200); } .progress-dot--active:not(.progress-dot--has-icon) { width: var(--dot-size); height: var(--dot-size); background: var(--progress-dot-active-background); box-shadow: 0px 0px 0px 4px var(--sl-color-primary-200); transition: all var(--sl-transition-medium) ease; } .progress-dot--active.progress-dot--has-icon .progress-dot--icon { display: flex; } .progress-dot--icon { display: none; } `;

// src/components/progress-dot/progress-dot.ts
var id = 0;
var FadvProgressDot = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "[default]");
    this.componentId = `progress-dot-${++id}`;
    this.active = false;
  }
  handleClick() {
    this.active = true;
  }
  handleActiveChange() {
    if (this.active) {
      emit(this, "progress-dot-activated", { detail: { value: this.value } });
    } else {
      emit(this, "progress-dot-deactivated", { detail: { value: this.value } });
    }
  }
  focus(options) {
    this.progressDot.focus(options);
  }
  render() {
    return $`<div role="tab" aria-label=${this.label ? this.label : t("components:progressDot.progressDot", { value: this.value })} aria-selected=${this.active ? "true" : "false"} tabindex=${this.active ? "0" : "-1"} id=${this.componentId} class=${o({
      "progress-dot": true,
      "progress-dot--active": this.active,
      "progress-dot--has-icon": this.hasSlotController.test("[default]")
    })} @click=${this.handleClick} ><div class="progress-dot--icon"><slot></slot></div></div>`;
  }
};
FadvProgressDot.styles = progress_dot_style_default;
__decorateClass([
  i(".progress-dot")
], FadvProgressDot.prototype, "progressDot", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvProgressDot.prototype, "active", 2);
__decorateClass([
  e({ reflect: true })
], FadvProgressDot.prototype, "value", 2);
__decorateClass([
  e()
], FadvProgressDot.prototype, "label", 2);
__decorateClass([
  watch("active")
], FadvProgressDot.prototype, "handleActiveChange", 1);
FadvProgressDot = __decorateClass([
  n("fadv-progress-dot")
], FadvProgressDot);

export {
  FadvProgressDot
};
